/* eslint-disable @typescript-eslint/naming-convention */
import { useEffect } from 'react';
import { useField } from 'react-final-form';

import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IKnmForm } from 'KnmPackage/MainModule/interfaces/IKnmForm';

interface UseSyncManualAddressProps {
  formRef: IKnmFormRef | undefined;
  name: string | undefined;
  prefix: 'location' | 'work' | 'factual';
  targetFieldName: string;
  shouldSync: boolean;
}

export const useSyncManualAddress = ({
  formRef,
  name,
  prefix,
  targetFieldName,
  shouldSync,
}: UseSyncManualAddressProps) => {
  const notInFiasField = useField(`${name}.${prefix}_notInFIAS`, { subscription: { value: true } });
  const manualAddressField = useField(`${name}.${prefix}_manualAddress`, { subscription: { value: true } });
  const regionField = useField(`${name}.${prefix}_region`, { subscription: { value: true } });
  const regionNameField = useField(`${name}.${prefix}_regionName`, { subscription: { value: true } });

  const notInFIAS = notInFiasField.input.value;
  const manualAddress = manualAddressField.input.value;
  const region = regionField.input.value;
  const regionName = regionNameField.input.value;

  useEffect(() => {
    if (!shouldSync || !notInFIAS || !manualAddress) return;

    const regionLabel =
      (region && typeof region === 'object' && 'label' in region ? region.label : null) || regionName || '';

    const finalAddress = regionLabel ? `${regionLabel}, ${manualAddress}` : manualAddress;

    formRef?.current.change(targetFieldName as keyof IKnmForm, finalAddress);
  }, [shouldSync, notInFIAS, manualAddress, region, regionName, formRef, targetFieldName]);
};
